import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { translateComponent } from '@/utils/tolgee/translateComponent';

export interface LomavisUpgradeSubscriptionButton1Props
  extends Omit<ButtonProps, 'children'> {
  /** Any react-bootstrap Button props can be passed (size, variant, etc.) */
}

export const LomavisUpgradeSubscriptionButton1: React.FC<
  LomavisUpgradeSubscriptionButton1Props
> = ({ variant = 'primary', size = 'lg', className = '', ...rest }) => {
  const t = translateComponent('LomavisUpgradeSubscriptionButton1');

  return (
    <Button
      href="/subscription-management/select/"
      variant={variant}
      size={size}
      className={`d-inline-flex align-items-center ${className}`}
      {...rest}
    >
      <i className="fa-regular fa-rocket-launch me-2"></i>
      {t('upgrade')}
    </Button>
  );
};
